define('views/modules/member/member/member-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/i18n',
    'services/events/user-events',
    'services/user',
    // collections
    'models/member/profile',
    // views
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-action',
    'views/parts/form/textbox',
    'views/parts/menu/menu-dropdown',
    'views/modules/member/member/member-lists-controller',
    'views/modules/member/member/edit/member-create-panel',
    'views/modules/member/member/edit/member-edit-panel',
    'views/modules/member/group-panel',
    // templates
    'text!templates/modules/member/member/member-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    i18n,
    UserEvents,
    User,
    // collections
    MProfile,
    // views
    VTreeView,
    VMenuAction,
    VTextBox,
    VMenuDropdown,
    VMemberListsController,
    VMemberCreatePanel,
    VMemberEditPanel,
    VGroupPanel,
    // templates
    TMemberContent
) {

    var VMemberContent = Backbone.View.extend({
        template: TMemberContent,
        regions: {
            root: "#member-list",
            menu: "#member-panel-actions",
            search: ".search-placeholder",
            groups: "#group-menu",
            edit: {
                elem: "#edit-member",
                form: "#edit-member-form",
            },
            lists: "#member-lists-controller",
        },

        initialize: function(opt) {
            opt = opt || {};
            this.url = opt.url;

            var groupTreeView = new VTreeView({
                label: 'name',
                subgroup: 'subgroups',
                activeAttribute: '_menuActive',
                depth: 5,
                toggleActive: true,
                firstOpen: true,
                collection: this.collection
            });

            var view = this.view = {
                menu: new VMenuAction({
                    context: this,
                    // radio: false,
                    onClick: this.onActionClicked,
                    collection: new Backbone.Collection([
                        { route: '#', title: i18n.t('messages:tooltip-add-client'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddMemberAction },
                        { route: '#', title: i18n.t('messages:tooltip-search'), icon: 'sl-icon-magnifier', toggle: true, callback: this.onSearchAction }
                    ]),
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                search: new VTextBox({ label: 'Search', attribute: 'query' }),
                groups: new VMenuDropdown({
                    context: this,
                    treeView: groupTreeView,
                    callback: this.onDisplayGroupManager,
                    //displayManageGroup: User.getMainGroup().isOwner,
                    collection: new Backbone.Collection([
                        // { icon: "sl-icon-people", label: "Show all members", callback: this.onShowAllMember },
                        // { separator: true },
                        { tree: true, tree_only: true, view: groupTreeView }
                    ]),
                }),

                lists: new VMemberListsController({
                    url: this.url,
                    model: this.model, // profile
                    groups: this.collection,
                }),
            };

            // groups collection
            this.listenTo(this.collection, {
                'update': this.onGroupCollectionUpdate,
                'click': this.onGroupClick
            });
            this.listenTo(groupTreeView, 'click', this.onSelectGroup);
            this.listenTo(view.lists, {
                'member:select': this.onMemberSelect,
                'member:edit': this.onMemberEdit,
                'member:remove': this.onMemberRemove,
            });

            this.listenTo(view.search, 'submit', this.onQuerySubmit);
            this.listenTo(view.search, 'change', this.onChange);
            this.listenTo(UserEvents, {
                "profile:editFromProfile": this.onEditMemberFromProfile,
                "onAddClientClick": this.onAddClientClick,
                "profile:fetchComplete": this.onUserFetchComplete,
                "group:modify": this.onGroupModify,
                "member:added": this.onMemberCreate,
                "member:getMemberFullList": this.onGetMemberFullList,
                "testUserAdded": this.onTestUserAdded
            });
        },

        render: function() {

            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;
            return this.assign(view.menu, zone.$menu)
                .assign(view.search, zone.$search)
                .assign(view.groups, zone.$groups)
                .assign(view.lists, zone.$lists);
        },

        toggleAddForm: function(val) {
            this.zone.add.$elem.toggle(val);
        },

        /////////////
        // actions //
        /////////////
        onGetMemberFullList: function() {
            UserEvents.sendMemberFullList(this.view.lists);
        },

        onMemberCreate: function(newMember) {
            this.onSelectGroup(newMember.get("group"));
        },

        onGroupModify: function() {
            this.collection.fetch({
                context: this,
                reset: true
            }).done(this.view.groups.render());
        },

        onUserFetchComplete: function() {
            this.view.groups.options.displayManageGroup = User.getMainGroup().isOwner;
            this.view.groups.render();
        },

        onDisplayGroupManager: function() {
            var grpPanel = new VGroupPanel();
            this.trigger('panel:stack', grpPanel);
        },

        onEditMemberFromProfile: function(member, e) {
          e.preventDefault();
          var view = this.view,
              edit = view.edit;

          if (!edit) {
              edit = this.edit = new VMemberEditPanel({
                  model: member,
                  groups: this.view.groups,
                  selectedGroup: this.selectedGroup,
                  memberList: this.view.lists,
              });
          }

          this.trigger('panel:stack', edit);
        },

        onActionClicked: function(e, actionModel) {
            e.preventDefault();
        },

        onSearchAction: function(e, itemModel) {
            if (itemModel.get('active')) {
                this.zone.$search.fadeIn(300);
            } else {
                this.onQuerySubmit(null, "");
                this.view.search.model.set("query", "");
                this.zone.$search.fadeOut(300);
            }
        },

        onAddMemberAction: function() {
            if (User.get('_allow_manage_members') === false) {
                Bootbox.alert({
                    title: i18n.t('sorry'),
                    message: i18n.t('cannot-add-clients-to-this-group')
                });
                return;
            }

            this.newMember = new MProfile();

            this.view.create = new VMemberCreatePanel({
                model: this.newMember,
                selectedGroup: this.selectedGroup,
                memberList: this.view.lists,
            });

            this.trigger('panel:stack', this.view.create);

        },

        redirectToUrl: function(redirectUrl, userId) {
            this.selectedMember = userId;

            Backbone.history.navigate(Mustache.render(redirectUrl, {
                groupId: this.selectedGroup.id,
                userId: userId
            }), { trigger: true });
        },

        getSelectedMember: function() {
            if (_.isUndefined(this.selectedMember)) {
                var fragment = Backbone.history.getFragment().split('/');
                var index = fragment.indexOf('member') + 1;
                this.selectedMember = User.get('_fallbackMemberId');

                if (fragment[index] === "me") {
                    this.selectedMember = User.id;
                }
            }

            return this.selectedMember;
        },

        ////////////
        // events //
        ////////////

        onChange: function(content) {
          if (content === "") {
            this.onQuerySubmit(null, content);
          }
        },

        onQuerySubmit: function(model, value) {
            if (this.currentQuery === value) return;
            var view = this.view.lists;

            view.setQuery(value);
            view.resetMemberList(this.selectedGroup);
            this.currentQuery = value;
        },

        onGroupCollectionUpdate: function() {
            if (!this.selectedGroup) {
                this.onSelectGroup(this.collection.first());
            }
            this.view.lists.resetMemberList(this.selectedGroup);
        },

        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup;
            if (groupModel !== undefined && selectedGroup !== groupModel) {
                if (selectedGroup) {
                    selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = selectedGroup = groupModel;
                this.view.lists.resetMemberList(selectedGroup);
            }

            this.view.groups.setLabel(selectedGroup.get('name'));
            selectedGroup.set('_menuActive', true);
        },

        onNewMemberSync: function() {
            var model = this.view.add.getModel();
            if (!model.isNew()) {
                this.toggleAddForm(false);
                this.view.lists.addMember(model.clone());
            }
        },

        onMemberSelect: function(member, collection) {
            this.trigger('member:select');
            this.selectedMember = member.id;

            Backbone.history.navigate(Mustache.render(this.url, {
                groupId: this.selectedGroup.id,
                userId: member.id
            }), { trigger: true });
        },

        onMemberEdit: function(member, collection) {
            var view = this.view,
                edit = view.edit;

            if (!edit) {
                edit = this.edit = new VMemberEditPanel({
                    model: member,
                    groups: this.view.groups,
                    selectedGroup: this.selectedGroup,
                    memberList: this.view.lists,
                });
            }

            this.trigger('panel:stack', edit);
        },

        onMemberRemove: function() {
            var nextMember = this.view.lists.getFirstAvailable(),
                    userId = 'me',
                    redirectUrl = 'supervisor/group/{{{groupId}}}/noclient/';

            if (nextMember) {
                userId = nextMember.id;
                redirectUrl = this.url;
            }

            this.redirectToUrl(redirectUrl, userId);
        },

        onTestUserAdded: function(user, redirect) {
            this.onSelectGroup(this.collection.first());
            if (redirect) this.redirectToUrl(this.url, user.id);
        },

        onAddClientClick: function() {
            this.onAddMemberAction();
        }

    });

    return VMemberContent;

});

